import React from 'react';

import 'primeicons/primeicons.css';

export const ValuedIcon = ({ icon, value }) => {
    return (
        <div style={{ position: 'relative', marginRight: '30px' }}>
            <i className={icon} style={{ color: '#32a041', position: 'absolute', zIndex: 1 }}></i>
            <span style={{
                position: 'absolute',
                top: '-10px',
                right: '-30px',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                background: '#d32f2f',
                color: '#ffffff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                zIndex: 2
            }}>{value}</span>
        </div>
    );
};
